import script from "./ManageUsersPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManageUsersPage.vue?vue&type=script&lang=ts&setup=true"

import "./ManageUsersPage.vue?vue&type=style&index=0&id=c7a21b10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7a21b10"]])

export default __exports__